import { Table, TableProps } from "@tfg/ui"

import { useGetTableTranslations } from "~/hooks/table"

type Props<T> = { isFetching?: boolean } & Omit<TableProps<T>, "translations">

export const CustomTable = <T,>({ table, isFetching, ...props }: Props<T>) => {
  const tableTranslations = useGetTableTranslations()

  return (
    <Table
      table={table}
      translations={tableTranslations}
      isFetching={isFetching}
      {...props}
    />
  )
}
